import _ from "lodash";
import store from "services/redux/store";
import { addDataByGuid } from "services/redux/data/actions";
import { dataConstants } from "services/redux/data/constants";
import FetchCache from "utils/fetch/cached/FetchCache";
import FetchLunchOption from "utils/fetch/FetchLunchOption";

export default class FetchCachedLunchOption
{
	static logName = 'FetchCachedLunchOption';
	static values = null;
	static cacheUpdatedAt = null;
	
	static construct = () => {
		return (
			FetchCache.initialize( this, {
				identifier: 'lunchoptions',
				tables: [ 'lunch_options' ],
				onExpire: this.reload,
				updated_at_max_age: ( 5 * 60 ) // updated_at needs to be refresh at most each 5 minutes for this table
			}, this.process )
		);
	};

	static fetchAll = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		this.construct().then( () =>
			{
			return (
				FetchCache.sniff( this.cacheUpdatedAt, {
				onFresh: () => {
					if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
						callbackSuccess( this.values )
					}
				},
				onExpired: () => {
					this.reload( { callbackSuccess, callbackError, callbackStart } )
				}
		})
			);
		});
	}

	static reload = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		this.construct().then( () =>
			{
			return (
				FetchLunchOption.fetchAll({
					callbackStart: callbackStart,
					callbackError: callbackError,
					callbackSuccess: ( lunchOptions ) => {
						// Save to object
						this.process( lunchOptions );

						// Save to cache!
						FetchCache.storeData( this.cacheUpdatedAt, lunchOptions, true );

						if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
							callbackSuccess( lunchOptions );
						}
					}
				})
			);
		}
		);
	}

	static process = ( lunchOptions ) => {
		this.values = lunchOptions;
		store.dispatch( addDataByGuid( dataConstants.LUNCH_OPTIONS, this.values ) );
	}
}
